import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-timescan-scanned-into-event",
	templateUrl: "./timescan-scanned-into-event.component.html",
	styleUrls: ["./timescan-scanned-into-event.component.css"],
})
export class TimescanScannedIntoEventComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private gradelevelService: GradeLevelService,
		private dialogService: DialogService
	) {}

	report = {
		EntryDate: new Date(),
		TimeScanTypeID: 0,
		IncludeAbsent: false,
		IncludeInSchoolNoScan: true,
		GradeLevelID: 0,
		GroupID: 0,
		SortByID: "Status",
		SortDirectionID: "ASC",
		SchoolID: 0,
		ImageLogo: "",
	};

	SchoolSelectShowAllText: string = "All Schools";

	TimeScanTypeList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		{
			ID: "Status",
			Desc: "Status",
		},
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "ScanTime",
			Desc: "Scan Time",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 489;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadTimeScanType();
		this.loadGradeLevelList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadTimeScanType() {
		var result = this.reportService.TimeScanTypeGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.TimeScanTypeList = response;

				// this.TimeScanTypeList.unshift({
				// 	TimeScanTypeID: 0,
				// 	TimeScanTypeDesc: "All Types",
				// });

				this.report.TimeScanTypeID = this.TimeScanTypeList[0].TimeScanTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: EntryDate
		strParam += "," + moment(this.report.EntryDate).format("MM/DD/YYYY") + "|EntryDate";

		//Parameter 3: TimeScanTypeID
		strParam += "," + this.report.TimeScanTypeID + "|TimeScanTypeID";

		//Parameter 4: IncludeAbsent
		strParam += "," + (this.report.IncludeAbsent == true ? "1" : "0") + "|IncludeAbsent";

		//Parameter 5: IncludeInSchoolNoScan
		strParam += "," + (this.report.IncludeInSchoolNoScan == true ? "1" : "0") + "|IncludeInSchoolNoScan";

		//Parameter 6: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 7: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 8: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 9: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 10: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 11: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
